let elTableBody = ELEMENT.Table.components.TableBody;

const tableRow = {
  name: "DsfElTableRow",
  props: {
    rowData: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  render(h) {
    let cells = this.$scopedSlots.default({
      self: this.$parent,
      data: this.rowData
    });
    return h("tr", {}, cells);
  }
};

export default {
  name: "DsfElTableBody",
  mixins: [elTableBody],
  inject: {
    $dsfElTable: {
      default: null
    }
  },
  components: {
    trow: tableRow
  },
  computed: {
    fixedMark() {
      return this.getFixed(this.fixed);
    },
    table() {
      return this.$dsfElTable;
    },
    tableUseVirtulScroll() {
      return this.table.useVirtulScroll;
    }
  },
  created() {
    this.$table = this.table;
    this.table.tbodys[this.fixedMark] = this;
  },
  mounted() {
    // 监听表体尺寸变
    if (!this.table.useVirtulScroll && this.fixedMark == "main") {
      this.bodyObserver = new ResizeObserver(() => {
        this.debounceSyncRowHeight();
      });
      this.startResizeObserver();
    }
    this.debounceSyncRowHeight = _.debounce(this._syncRowHeight, 200);
  },
  methods: {
    isColumnHidden(index) {
      if (this.table.isSticky) {
        return false;
      } else {
        return elTableBody.methods.isColumnHidden.call(this, index);
      }
    },
    isColumnFixed(index) {
      let info = { pos: null, last: false };
      if (index < this.leftFixedLeafCount) {
        info.pos = "left";
        info.last = index >= this.leftFixedLeafCount - 1;
      } else if (index >= this.columnsCount - this.rightFixedLeafCount) {
        info.pos = "right";
        info.last = index == this.columnsCount - this.rightFixedCount;
      } else {
        info.pos = null;
      }
      return info;
    },
    startResizeObserver() {
      this.bodyObserver && this.bodyObserver.observe(this.$refs.body);
    },
    endResizeObserver() {
      this.bodyObserver && this.bodyObserver.unobserve(this.$refs.body);
    },
    _syncRowHeight() {
      if (!this.table.useVirtulScroll && this.fixedMark == "main" && this.data.length > 0) {
        this.syncRowHeight();
      }
    },
    syncRowHeight() {
      if (!this.table.isSticky) {
        let heights = [];
        let tr = this.$refs.body.querySelectorAll(".el-table__row");
        tr.forEach((row, i) => {
          let index = row.getAttribute("row-index");
          row.style.height = "auto";
          let realHeight = row.getBoundingClientRect().height;
          heights.push({
            elm: row,
            index: i,
            height: realHeight
          });
        });
        let left_tr = this?.table?.$refs?.fixedBodyWrapper?.querySelectorAll?.(".el-table__row") || null;
        let right_tr = this?.table?.$refs?.rightFixedBodyWrapper?.querySelectorAll?.(".el-table__row") || null;
        //将表格主体的行高同步给左右两侧冻结区域表格行高
        _.each(heights, (h) => {
          if (left_tr && left_tr.length > 0 && left_tr[h.index]) {
            left_tr[h.index].style.height = this.unitSize(h.height);
          }
          if (right_tr && right_tr.length > 0 && right_tr[h.index]) {
            right_tr[h.index].style.height = this.unitSize(h.height);
          }
        });
      }
    },
    getFixed(fixed) {
      if (fixed == "left" || fixed == "right") {
        return fixed;
      } else if (fixed === true) {
        return "left";
      } else {
        return "main";
      }
    },
    //重写行render函数，
    rowRender(row, $index, treeRowData) {
      const { treeIndent, columns, firstDefaultColumnIndex, table, fixedMark } = this;
      // const columnsHidden = columns.map((column, index) => this.isColumnHidden(index));
      const rowClasses = this.getRowClass(row, $index);
      let display = true;
      if (treeRowData) {
        rowClasses.push("el-table__row--level-" + treeRowData.level);
        display = treeRowData.display;
      }
      // 指令 v-show 会覆盖 row-style 中 display
      // 使用 :style 代替 v-show https://github.com/ElemeFE/element/issues/16995
      let displayStyle = display
        ? null
        : {
          display: "none"
        };
      let h = this.$createElement;

      let rowStyle = {};
      let height = "";
      if (table.useVirtulScroll) {
        height = this.unitSize(this.table.minRowHeight);
      }
      if (table.useVirtulScroll) {
        rowStyle.height = height;
      }

      return h("trow", {
        style: [displayStyle, this.getRowStyle(row, $index), rowStyle],
        class: rowClasses,
        attrs: {
          "row-index": $index
        },
        props: {
          rowData: row
        },
        // key: $index,
        scopedSlots: {
          default(props) {
            return props.self.renderRowSlot(h, props, row, treeRowData, $index);
          }
        },
        key: table.useVirtulScroll ? $index : this.getKeyOfRow(row, $index),
        nativeOn: {
          dblclick: ($event) => this.handleDoubleClick($event, row),
          click: ($event) => this.handleClick($event, row),
          contextmenu: ($event) => this.handleContextMenu($event, row),
          mouseenter: (_) => this.handleMouseEnter($index),
          mouseleave: this.handleMouseLeave
        }
      });
    },
    renderRowSlot(h, props, row, treeRowData, $index) {
      const { treeIndent, columns, firstDefaultColumnIndex, table, fixedMark } = this;
      const columnsHidden = columns.map((column, index) => this.isColumnHidden(index));
      let data = props.data;
      let self = this;
      //加载表格内容
      let renderColumns = columns.map((column, cellIndex) => {
        let mark = true;
        if (self.fixedMark == "left" || self.fixedMark == "right") {
          if (self.getFixed(column.fixed) != self.fixedMark) {
            mark = false;
          }
        }
        const { rowspan, colspan } = self.getSpan(row, column, $index, cellIndex);
        if (!rowspan || !colspan) {
          return null;
        }
        const columnData = { ...column };
        columnData.realWidth = self.getColspanRealWidth(columns, colspan, cellIndex);
        const data = {
          store: self.store,
          _self: self.context || self.table.$vnode.context,
          column: columnData,
          row,
          $index
        };
        if (cellIndex === firstDefaultColumnIndex && treeRowData) {
          data.treeNode = {
            indent: treeRowData.level * treeIndent,
            level: treeRowData.level
          };
          if (typeof treeRowData.expanded === "boolean") {
            data.treeNode.expanded = treeRowData.expanded;
            // 表明是懒加载
            if ("loading" in treeRowData) {
              data.treeNode.loading = treeRowData.loading;
            }
            if ("noLazyChildren" in treeRowData) {
              data.treeNode.noLazyChildren = treeRowData.noLazyChildren;
            }
          }
        }
        let fixedInfo = self.isColumnFixed(cellIndex);
        let fastScroll = self.table.fastScroll;

        let notShowCellContent = false;
        let columnInRange = true;
        //如果是虚拟滚动，判断当前单元格是否超出可显示的列范围
        if (this.table.useVirtulScroll) {
          if (this.table.startColIndex > cellIndex || this.table.endColIndex < cellIndex) {
            columnInRange = false;
          }
          //如果当前列是一个冻结列，强制显示
          columnInRange = fixedInfo.pos == "left" || fixedInfo.pos == "right" ? true : columnInRange;
        }
        if (fastScroll) {
          if (this.table.currScrollPos == "y") {
            notShowCellContent = fixedInfo.pos == "left" ? false : true;
          } else {
            notShowCellContent = fixedInfo.pos == "left" || fixedInfo.pos == "right" ? false : true;
          }
        }
        let renderCellContent = null;
        if (notShowCellContent) {
          renderCellContent = "加载中";
        } else {
          if (mark) {
            //不在可视区域的列不显示
            if (columnInRange) {
              renderCellContent = [self.renderCell(column, data, self.$createElement, columnsHidden, cellIndex)];
            } else {
              renderCellContent = [h()];
            }
          } else {
            renderCellContent = [h()];
          }
        }
        let cell = (
          <td
            style={[self.getCellStyle($index, cellIndex, row, column)]}
            class={self.getCellClass($index, cellIndex, row, column)}
            rowspan={rowspan}
            colspan={colspan}
            // hook={
            //   update:function (oldDom, newDom) {

            //   }
            // }
            on={{
              mouseenter: ($event) => self.handleCellMouseEnter($event, row),
              mouseleave: self.handleCellMouseLeave
            }}
          >
            {renderCellContent}
          </td>
        );
        return cell;
      });
      return renderColumns;
    },
    renderCell(column, data, h, columnsHidden, cellIndex) {
      return column.renderCell.call(this._renderProxy, h, data, columnsHidden[cellIndex]);
    },
    getCellStyle(rowIndex, columnIndex, row, column) {
      let cellStyle = this.table.cellStyle || {};
      let result = cellStyle;
      if (typeof cellStyle === "function") {
        result = cellStyle.call(null, {
          rowIndex,
          columnIndex,
          row,
          column
        });
      }
      if (this.table.isSticky) {
        let info = this.isColumnFixed(columnIndex);
        let pos = info.pos;
        if (pos == "left") {
          let sum = 0;
          for (let i = 0; i < columnIndex; i++) {
            sum += this?.columns?.[i]?.realWidth || this?.columns?.[i]?.width || 0;
          }
          result[pos] = dsf.unitSize(sum);
          result.position = "sticky";
          result["z-index"] = 2;
        } else if (pos == "right") {
          let sum = 0;
          for (let i = this.columnsCount; i > columnIndex; i--) {
            sum += this?.columns?.[i]?.realWidth || this?.columns?.[i]?.width || 0;
          }
          result[pos] = dsf.unitSize(sum);
          result.position = "sticky";
          result["z-index"] = 2;
        }
      }
      return result;
    },
    getCellClass(rowIndex, columnIndex, row, column) {
      let classes = elTableBody.methods.getCellClass.call(this, rowIndex, columnIndex, row, column);
      if (this.table.isSticky) {
        let info = this.isColumnFixed(columnIndex);
        if (info.pos === "left" && info.last) {
          classes += " el-table-fixed-last";
        } else if (info.pos == "right" && info.last) {
          classes += " el-table-fixed-right-last";
        }
      }
      return classes;
    }
  },
  updated() {
    // console.log("update-tbody");
  },
  beforeDestroy() {
    delete this.$table.tbodys[this.fixedMark];
    delete this.$table;
    this.bodyObserver && this.bodyObserver.disconnect();
  },
  render(h) {
    const data = this.data || [];
    let acc = [];
    let rows = [];
    if (this.table.useVirtulScroll) {
      let pageData = this.data.slice(this.table.startIndex, this.table.endIndex + 1);
      _.each(pageData || [], (row, i) => {
        let index = this.table.startIndex + i;
        let rowVnode = this.wrappedRowRender(row, index);
        rows.push(rowVnode);
      });
    } else {
      rows = this.data.reduce((acc, row) => {
        let rowVnode = this.wrappedRowRender(row, acc.length);
        return acc.concat(rowVnode);
      }, []);
    }
    let vnodes = (
      <table class="el-table__body" cellspacing="0" cellpadding="0" border="0">
        <colgroup>
          {this.columns.map((column) => (
            <col name={column.id} key={column.id} />
          ))}
        </colgroup>
        <tbody ref="body">
          {rows}
          {/* <el-tooltip effect={this.table.tooltipEffect} placement="top" ref="tooltip" content={this.tooltipContent}></el-tooltip> */}
        </tbody>
      </table>
    );
    return vnodes;
  }
};
